<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        Last Run per Login
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="lastRunExpanded = !lastRunExpanded"
        >
          <span v-if="!lastRunExpanded">Expand</span>
          <span v-if="lastRunExpanded">Collapse</span>
        </button>
      </p>
      <table
        v-if="lastRunExpanded"
        class="table table-striped table-bordered with-header-border"
      >
        <thead>
          <tr>
            <th colspan="5" />
            <th colspan="5">
              Processing Stats
            </th>
            <th colspan="2" />
            <th colspan="3">
              Changelog
            </th>
          </tr>
          <tr>
            <th>Run</th>
            <th>
              <a
                href="#"
                @click.prevent="sortByAsc( e => e.agentCode )"
              >
                Agent
              </a>
            </th>
            <th>Config</th>
            <th>
              <a
                href="#"
                @click.prevent="sortByAsc( e => e.start )"
              >
                Start
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortByAsc( e => e.end )"
              >
                End
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingStats ? e.processingStats.online : 0 )"
              >
                Valid
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingStats ? e.processingStats.offline : 0 )"
              >
                Valid over service limit
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingStats ? e.processingStats.invalid : 0 )"
              >
                Invalid
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingStats ? e.processingStats.unmatched : 0 )"
              >
                Excluded
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingStats && e.processingStats.ignored ? e.processingStats.ignored : 0 )"
              >
                Ignored
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.processingError ? e.processingError.length : 0 )"
              >
                Processing Error
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.dbWriteError ? e.dbWriteError.length : 0 )"
              >
                DB Write Error
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.changeLog && e.changeLog.inserted ? e.changeLog.inserted.length : 0 )"
              >
                Inserted
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.changeLog && e.changeLog.offline ? e.changeLog.offline.length : 0 )"
              >
                Offline
              </a>
            </th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.changeLog && e.changeLog.updated ? Object.keys( e.changeLog.updated ).length : 0 )"
              >
                Updated
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="entry in entries"
            :key="entry.id"
          >
            <td>{{ entry.id }}</td>
            <td>
              <a :href="'/xmlimport?login=' + entry.agentCode">
                {{ entry.agentCode }}
              </a>
            </td>
            <td>
              properties: {{ entry.runConfig.numberOfProperties }} <span v-if="validPromotion( entry )">(upgraded to {{ entry.runConfig.promotionalProperties }})</span>
              <br>schema: {{ entry.runConfig.importSchema }}
              <br>swap feed: {{ entry.runConfig.swapFeed ? 'yes' : 'no' }}
              <br>order: {{ order( entry ) }}
              <br v-if="entry.runConfig.cleanDescriptions">
              <span v-if="entry.runConfig.cleanDescriptions">clean descriptions: {{ entry.runConfig.cleanDescriptions }}</span>
            </td>
            <td>{{ toLocaleString( entry.start ) }}</td>
            <td>{{ toLocaleString( entry.end ) }}</td>
            <td>
              {{ entry.processingStats ? entry.processingStats.online : '' }}
            </td>
            <td>
              {{ entry.processingStats ? entry.processingStats.offline : '' }}
            </td>
            <td>
              {{ entry.processingStats ? entry.processingStats.invalid : '' }}
            </td>
            <td>
              {{ entry.processingStats ? entry.processingStats.unmatched : '' }}
            </td>
            <td>
              {{ entry.processingStats ? ( entry.processingStats.ignored ? entry.processingStats.ignored : 0 ) : '' }}
            </td>
            <td style="max-width: 100px;">
              {{ formatError( entry.processingError ) }}
            </td>
            <td style="max-width: 100px;">
              {{ formatError( entry.dbWriteError ) }}
            </td>
            <td>
              {{ entry.changeLog && entry.changeLog.inserted ? entry.changeLog.inserted.length : 0 }}
            </td>
            <td>
              {{ entry.changeLog && entry.changeLog.offline ? entry.changeLog.offline.length : 0 }}
            </td>
            <td>
              {{ entry.changeLog && entry.changeLog.updated ? Object.keys( entry.changeLog.updated ).length : 0 }}
            </td>
          </tr>
        </tbody>
      </table>
      <p class="card-text mb-3">
        Feed Validation Errors
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="feedValidationErrorsExpanded = !feedValidationErrorsExpanded"
        >
          <span v-if="!feedValidationErrorsExpanded">Expand</span>
          <span v-if="feedValidationErrorsExpanded">Collapse</span>
        </button>
      </p>
      <div
        class="alert alert-info"
        v-if="feedValidationErrorsExpanded && feedValidationErrors.length === 0"
      >
        No feed validation errors
      </div>
      <table
        class="table table-striped table-bordered with-header-border"
        v-if="feedValidationErrorsExpanded && feedValidationErrors.length > 0"
      >
        <thead>
          <th>Issue</th>
          <th>Count</th>
          <th>Logins</th>
        </thead>
        <tbody>
          <tr
            v-for="err in feedValidationErrors"
            :key="err.message"
          >
            <td>{{ err.message }}</td>
            <td>{{ err.count }}</td>
            <td>
              <span
                v-for="l in err.logins"
                :key="l"
              >
                <a
                  :href="'/xmlimport?login=' + l"
                >
                  {{ l }}
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="card-text mb-3">
        Feed Validation Warnings
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="feedValidationWarningsExpanded = !feedValidationWarningsExpanded"
        >
          <span v-if="!feedValidationWarningsExpanded">Expand</span>
          <span v-if="feedValidationWarningsExpanded">Collapse</span>
        </button>
      </p>
      <table
        class="table table-striped table-bordered with-header-border"
        v-if="feedValidationWarningsExpanded"
      >
        <thead>
          <th>Issue</th>
          <th>Count</th>
          <th>Logins</th>
        </thead>
        <tbody>
          <tr
            v-for="err in feedValidationWarnings"
            :key="err.message"
          >
            <td>{{ err.message }}</td>
            <td>{{ err.count }}</td>
            <td>
              <span
                v-for="l in err.logins"
                :key="l"
              >
                <a
                  :href="'/xmlimport?login=' + l"
                >
                  {{ l }}
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="card-text mb-3">
        Property validation errors
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="processingErrorsExpanded = !processingErrorsExpanded"
        >
          <span v-if="!processingErrorsExpanded">Expand</span>
          <span v-if="processingErrorsExpanded">Collapse</span>
        </button>
      </p>
      <table
        class="table table-striped table-bordered with-header-border"
        v-if="processingErrorsExpanded"
      >
        <thead>
          <th>Issue</th>
          <th>Count</th>
          <th>Top 20 logins</th>
        </thead>
        <tbody>
          <tr
            v-for="issue in validationIssues"
            :key="issue.message"
          >
            <td>{{ issue.message }}</td>
            <td>{{ issue.total }}</td>
            <td>
              <span
                v-for="l in issue.logins.slice( 0, 20 )"
                :key="l.login"
              >
                <a
                  :href="'/xmlimport?login=' + l.login"
                >
                  {{ l.login }}
                </a>
                <span class="badge badge-secondary">{{ l.total }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="card-text mb-3">
        Property reading issues
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="processingIssuesExpanded = !processingIssuesExpanded"
        >
          <span v-if="!processingIssuesExpanded">Expand</span>
          <span v-if="processingIssuesExpanded">Collapse</span>
        </button>
      </p>
      <table
        class="table table-striped table-bordered with-header-border"
        v-if="processingIssuesExpanded"
      >
        <thead>
          <th>Issue</th>
          <th>Count</th>
          <th>Top 20 logins</th>
        </thead>
        <tbody>
          <tr
            v-for="issue in issues"
            :key="issue.message"
          >
            <td>{{ issue.message }}</td>
            <td>{{ issue.total }}</td>
            <td>
              <span
                v-for="l in issue.logins.slice( 0, 20 )"
                :key="l.login"
              >
                <a
                  :href="'/xmlimport?login=' + l.login"
                >
                  {{ l.login }}
                </a>
                <span class="badge badge-secondary">{{ l.total }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';

export default {
    data() {
        return {
            login: '',
            entries: [],
            issues: [],
            validationIssues: [],
            feedValidationWarnings: [],
            feedValidationErrors: [],
            lastRunExpanded: false,
            feedValidationErrorsExpanded: false,
            feedValidationWarningsExpanded: false,
            processingErrorsExpanded: false,
            processingIssuesExpanded: false
        };
    },
    async mounted() {
        this.search();
    },
    methods: {
        formatLatLngInfo( property ) {
            if ( !property.property.latitude || !property.property.longitude ) {
                return '';
            }
            return `${property.property.latitude}, ${property.property.longitude}`;
        },
        formatError( dbError ) {
            if ( !dbError ) {
                return '';
            }

            if ( dbError.length < 300 ) {
                return dbError;
            }

            return dbError.substring( 0, 300 ) + ' ...';
        },
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );
            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        sortBy( expression ) {
            this.entries.sort( ( a, b ) => {
                if ( expression( a ) > expression( b ) ) {
                    return -1;
                }

                if ( expression( a ) < expression( b ) ) {
                    return 1;
                }

                return 0;
            } );
        },
        sortByAsc( expression ) {
            this.entries.sort( ( a, b ) => {
                if ( expression( a ) > expression( b ) ) {
                    return 1;
                }

                if ( expression( a ) < expression( b ) ) {
                    return -1;
                }

                return 0;
            } );
        },
        sort( entries ) {
            entries.sort( ( a, b ) => {
                if ( a.dbWriteError.length == b.dbWriteError.length ) {
                    // compare via dbError
                    if ( a.processingError.length > b.processingError.length ) {
                        return -1;
                    }

                    if ( a.processingError.length < b.processingError.length ) {
                        return 1;
                    }

                    return 0;
                }

                if ( a.dbWriteError.length > b.dbWriteError.length ) {
                    return -1;
                }

                return 1;
            } );
        },
        validPromotion( entry ) {
            if ( !entry.runConfig.promotionStartDate || !entry.runConfig.promotionEndDate ) {
                return false;
            }
            const promotionStartDate = new Date( entry.runConfig.promotionStartDate );
            const promotionEndDate = new Date( entry.runConfig.promotionEndDate );

            const start = new Date( entry.start );

            return start >= promotionStartDate && start <= promotionEndDate;
        },
        order( entry ) {
            if ( !entry.runConfig.sortType ) {
                return '';
            }

            switch ( entry.runConfig.sortType ) {
            case 0:
                return 'with photos, as in the feed';
            case 1:
                return 'with photos, date descending';
            case 2:
                return 'with photos, price ascending';
            case 3:
                return 'with photos, price descending';
            case 4:
                return 'manual';
            case 5:
                return 'custom';
            default:
                return 'unknown';
            }
        },
        async search() {
            this.$store.dispatch( 'appLoading', true );

            var url = '/lastrunperactiveagent';

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load import history'
                } );
                return;
            }

            let entries = await response.json();

            this.sort( entries );

            this.entries = entries;

            this.updateValidationIssues( entries );

            this.updateIssues( entries );

            this.updateFeedIssues( entries );

            this.$store.dispatch( 'appLoading', false );
        },
        updateFeedIssues( entries ) {
            const validationWarnings = [];
            const validationErrors = [];

            for ( const entry of entries ) {
                if ( !entry.processingStats || !entry.processingStats.feedValidationWarnings ) {
                    continue;
                }
                for ( const warn of entry.processingStats.feedValidationWarnings ) {
                    const warnIndex = validationWarnings.findIndex( w => w.message === warn );

                    if ( warnIndex === -1 ) {
                        validationWarnings.push( {
                            message: warn,
                            count: 1,
                            logins: [ entry.agentCode ]
                        } );
                    } else {
                        validationWarnings[ warnIndex ].count++;
                        validationWarnings[ warnIndex ].logins.push( entry.agentCode );
                    }
                }
            }

            for ( const entry of entries ) {
                if ( !entry.processingStats || !entry.processingStats.feedValidationErrors ) {
                    continue;
                }
                for ( const err of entry.processingStats.feedValidationErrors ) {
                    const errIndex = validationErrors.findIndex( w => w.message === err );

                    if ( errIndex === -1 ) {
                        validationErrors.push( {
                            message: err,
                            count: 1,
                            logins: [ entry.agentCode ]
                        } );
                    } else {
                        validationErrors[ errIndex ].count++;
                        validationErrors[ errIndex ].logins.push( entry.agentCode );
                    }
                }
            }

            validationWarnings.sort( ( a, b ) => {
                if ( a.count > b.count ) {
                    return -1;
                }

                if ( a.count < b.count ) {
                    return 1;
                }

                return 0;
            } );

            validationErrors.sort( ( a, b ) => {
                if ( a.count > b.count ) {
                    return -1;
                }

                if ( a.count < b.count ) {
                    return 1;
                }

                return 0;
            } );

            this.feedValidationWarnings = validationWarnings;
            this.feedValidationErrors = validationErrors;
        },
        updateIssues( entries ) {
            const issues = [];

            for ( const entry of entries ) {
                if ( !entry.processingStats || !entry.processingStats.issues ) {
                    continue;
                }
                for ( const issue of entry.processingStats.issues ) {
                    const issueIndex = issues.findIndex( i => i.message === issue.message );

                    if ( issueIndex === -1 ) {
                        issues.push( {
                            message: issue.message,
                            total: issue.total,
                            logins: [
                                { login: entry.agentCode, total: issue.total }
                            ]
                        } );
                    } else {
                        issues[ issueIndex ].total += issue.total;

                        const loginIndex = issues[ issueIndex ].logins.findIndex( l => l.login === entry.agentCode );

                        if ( loginIndex === -1 ) {
                            issues[ issueIndex ].logins.push( { login: entry.agentCode, total: issue.total } );
                        } else {
                            issues[ issueIndex ].logins[ loginIndex ].total += issue.total;
                        }
                    }
                }
            }

            issues.sort( ( a, b ) => {
                if ( a.total > b.total ) {
                    return -1;
                }

                if ( a.total < b.total ) {
                    return 1;
                }

                return 0;
            } );

            for ( let issue of issues ) {
                issue.logins.sort( ( a, b ) => {
                    if ( a.total > b.total ) {
                        return -1;
                    }

                    if ( a.total < b.total ) {
                        return 1;
                    }

                    return 0;
                } );
            }

            this.issues = issues;
        },
        updateValidationIssues( entries ) {
            const issues = [];

            for ( const entry of entries ) {
                if ( !entry.processingStats || !entry.processingStats.validationIssues ) {
                    continue;
                }
                for ( const issue of entry.processingStats.validationIssues ) {
                    const issueIndex = issues.findIndex( i => i.message === issue.message );

                    if ( issueIndex === -1 ) {
                        issues.push( {
                            message: issue.message,
                            total: issue.total,
                            logins: [
                                { login: entry.agentCode, total: issue.total }
                            ]
                        } );
                    } else {
                        issues[ issueIndex ].total += issue.total;

                        const loginIndex = issues[ issueIndex ].logins.findIndex( l => l.login === entry.agentCode );

                        if ( loginIndex === -1 ) {
                            issues[ issueIndex ].logins.push( { login: entry.agentCode, total: issue.total } );
                        } else {
                            issues[ issueIndex ].logins[ loginIndex ].total += issue.total;
                        }
                    }
                }
            }

            issues.sort( ( a, b ) => {
                if ( a.total > b.total ) {
                    return -1;
                }

                if ( a.total < b.total ) {
                    return 1;
                }

                return 0;
            } );

            for ( let issue of issues ) {
                issue.logins.sort( ( a, b ) => {
                    if ( a.total > b.total ) {
                        return -1;
                    }

                    if ( a.total < b.total ) {
                        return 1;
                    }

                    return 0;
                } );
            }

            this.validationIssues = issues;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/global.vue